module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-stats"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": _vm.color
    }
  }, [_vm._t("icon")], 2), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_vm._t("title")], 2), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "stats"
  }, [_vm._t("footer")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64c46760!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/Cards/StatsCard.vue
// module id = 164
// module chunks = 2